export const pluralize = (count: number, word: string): string => {
  if (count === 1) {
    return word;
  }

  if (/(s|x|z|ch|sh)$/i.test(word)) {
    return `${word}es`;
  }
  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }
  if (/fe$/i.test(word)) {
    return `${word.slice(0, -2)}ves`;
  }
  if (/f$/i.test(word)) {
    return `${word.slice(0, -1)}ves`;
  }

  return `${word}s`;
};
